module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-4-e0b5096d21cd39acc8e5ef3b3ede9e52.jpg";